import { render, staticRenderFns } from "./my-page.vue?vue&type=template&id=822487e0"
import script from "./my-page.vue?vue&type=script&lang=js"
export * from "./my-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/vercel/path0/components/ui/img.vue').default})
